import React,{Component} from 'react'
import {Link} from 'react-router-dom'
import './blogContent.css'

class BlogContent extends Component{

    
    render(){
            return (
            <div className='card'>
                <img src={this.props.blog.albumPhotos[0]} alt='test'/>
                <div className='detail-container'>
                <Link to={'/blog/'+this.props.blog.id} key={this.props.blog.id}>
                <h2>{this.props.blog.title}</h2>
                </Link>
                </div>
            </div>
        )
    }
}
    
export default BlogContent
